import { Portal } from 'cdk-radial';
import { useEffect, useState } from 'react';
import { Dropdown } from '../Dropdown/Dropdown';
import { DropdownType } from '../Dropdown/types';

export const MyPortal = ({
  isOpen,
  ...props
}: DropdownType): React.JSX.Element => {
  const [targetId, setTargetId] = useState<string>('');
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const handleClick = (elementId: string) => {
    setTargetId(elementId);
    setIsVisible(true);
  };
  useEffect(() => {
    if (isOpen) {
      handleClick('containerID');
    }
  }, [isOpen]);
  return (
    <>
      {isVisible && (
        <Portal id={targetId} isVisible={isVisible}>
          <Dropdown {...props} />
        </Portal>
      )}
    </>
  );
};
